import styled from 'styled-components';

export const BarStyle = styled.div`
    position: flex;
    width: 100%;
    height: 75px;
    left: 0px;
    top: 0px;
    background: #0085FF;
`

export const InputStyle = styled.input`
    border: none;
    -webkit-appearance:none;
    -ms-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background:
        linear-gradient(90deg, orange, orange) center bottom/0 3px no-repeat,
        linear-gradient(90deg, #0085FF, #0085FF) left bottom/100% 2px no-repeat,
        linear-gradient(90deg, white, white) left bottom/100% no-repeat;
    padding: 10px;
    border-radius: 0px;
    width: 130px;
    outline: none;
    font-size: 21px;
    transition: background-size 0.3s ease;
    &:focus {
        background-size: 100% 2px, 100% 2px, 100%;
    }
`

export const InputContainer = styled.div`
    position: relative;
    font-size: 20px;
    padding-top: 20px;
    margin-bottom: 5px;
    &input:valid{
        top: 10px;
        font-size: 16px;
        color: blue;
    }
`


export const SteelImage = styled.div`
    position: flex;
    width: 100%;
    padding-top: 3px;
    border-bottom: 2px solid #0085FF;
`
export const SteelImageStyle = styled.img`
    position: flex;
    max-width: 600px;
    max-height: 100%;
`

export const ImageStyle = styled.img`
    position: flex;
    max-width: 100%;
    max-height: 100%;
`

export const DropdownButton = styled.button`
    position: flex;
    background-color: transparent;
    color: #0085FF;
    padding: 10px;
    font-size: 20px;
    min-width: 50px;
    border-width: 0px;
    border-radius: 10px;
    border-style: solid;
    border-color: #0085FF;
    &:hover {
        border-color: #0059ff;
        color: #0059ff;
    }
`
export const DropdownOptions = styled.div`
    position: absolute;
    background-color: #f9f9f9;
    display: flex;
    flex-direction: column;
    min-width: 60px;
    width: 100%;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    z-index: 1;
`

let color = "blue"

export const DropdownOption = styled.button`
    position: flex;
    background-color: transparent;
    color: #0085FF;
    padding: 10px;
    font-size: 15px;
    min-width: 50px;
    border: none;
    &:hover {
        color: ${color};
    }
`
export const HorizontalSpaceContainer = styled.div`
    display: flex;
    justify-content: space-around;
`
export const VerticalSpaceContainer = styled.div`
    display : flex;
	flex-direction: column;
	justify-content:space-around;
`

export const DropdownContainer = styled.div`
    position: relative;
    display: inline-block;
    transform:scale(1.2);
    z-index: 1;
`
export const StyledButton = styled.button`
    width: 100vw;
    color: #004f99;
    font-size: 25px;
    background-color: transparent;
    border-style: solid;
    border-color: white;
    transition: 0.3s ease;
    border-radius: 0px;
    padding-top: 10px;
    padding-bottom: 10px;
    &:hover{
        border: none;
        color:white;
        background-color: #0085FF;
    }
`
export const Title = styled.div`
    font-size: 30px;
    color: #0085FF;
`

export const UnitContainer = styled.div`
    display: flex;
    justify-content: center;
`

export const UnitBox = styled.div`
    color: #006dd3;
    padding-left: 15px;
    display:flex;
    font-size:19px;
    transform: translateY(30px);
`